const CommonConstants = {
  API_PREFIX:
    process.env.NEXT_PUBLIC_PRODUCTION === 'true'
      ? process.env.NEXT_PUBLIC_API_PREFIX
      : 'http://localhost:8080',
  // Checklist MCP authorization server (checklist-auth). The consent page at /mcp/authorize talks to it.
  MCP_AUTH_API_PREFIX:
    process.env.NEXT_PUBLIC_MCP_AUTH_API_PREFIX || 'http://localhost:8799',
  AGENT_API_PREFIX:
    process.env.NEXT_PUBLIC_AGENT_API_PREFIX || 'http://127.0.0.1:8000',
  SEARCH_API_PREFIX:
    process.env.NEXT_PUBLIC_SEARCH_API_PREFIX || 'http://000000000:8000',
  OAUTH_CLIENT_ID:
    process.env.NEXT_PUBLIC_OAUTH_CLIENT_ID || 'default-client-id',
  OAUTH_CLIENT_SECRET:
    process.env.NEXT_PUBLIC_OAUTH_CLIENT_SECRET || 'default-client-secret',

  FREE_PLAN_MEMBERS_COUNT: 5,

  // The lifetime plan is a launch offer: claimable only within 24 hours of the
  // organization being created. The popup is held back for the first 10
  // minutes so a brand new user gets to look around before being sold to.
  LIFETIME_OFFER_WINDOW_MS: 24 * 60 * 60 * 1000,
  LIFETIME_OFFER_POPUP_DELAY_MS: 10 * 60 * 1000,

  DEFAULT_COLORS: [
    '#F76E11', // Vibrant Orange
    '#FF9F1C', // Bright Amber
    '#2EC4B6', // Aqua Green
    '#F4D06F', // Mustard Yellow
    '#3D5A80', // Deep Blue
    '#EE6C4D', // Coral
    '#6A4C93', // Deep Purple
    '#9B5DE5', // Lavender Purple
    '#FF6F61', // Soft Red
    '#118AB2' // Ocean Blue
  ],

  DEFAULT_STATUS_NAMES: [
    'Completed',
    'In Progress',
    'Needs Attention',
    'Not Applicable (N/A)'
  ]
};

export default CommonConstants;
